<div class="widget form-group">
  <label [attr.for]="id" class="horizontal control-label">
    {{ schema.title }}
    <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>
  <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  <span *ngIf="required" class="help-block required-message">* Required</span>
  <div *ngFor="let itemProperty of formProperty.properties; let i=index; trackBy:trackByIndex" class="widget-array-item">
    <sp-form-element [formProperty]="itemProperty"></sp-form-element>
    <button (click)="removeItem(i)" class="btn btn-default array-remove-button">
      <span class="glyphicon glyphicon-minus" aria-hidden="true"></span> {{ schema.options.btnRemove | default: 'Remove' }}
    </button>
  </div>
  <button (click)="addItem()" class="btn btn-default array-add-button">
    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span> {{ schema.options.btnAdd | default: 'Add' }}
  </button>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/array.widget.html